import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { C2, C2_FONT } from "./Table/C2UserTable";

/**
 * Campo de ficha de usuario (admin): etiqueta muted + valor.
 * Reemplaza el patrón antiguo de bloques morado/blanco partido.
 */
function Userinfo({ title, value }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const display =
    value === undefined || value === null || value === ""
      ? "—"
      : String(value);

  return (
    <Box
      sx={{
        direction: isRTL ? "rtl" : "ltr",
        width: "100%",
        bgcolor: C2.white,
        border: `1px solid ${C2.border}`,
        borderRadius: "14px",
        px: 2,
        py: 1.5,
        minHeight: 72,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 0.5,
        transition: "border-color 0.15s ease, box-shadow 0.15s ease",
        "&:hover": {
          borderColor: C2.bright,
          boxShadow: "0 4px 14px rgba(100,17,237,0.08)",
        },
      }}
    >
      <Typography
        sx={{
          fontFamily: C2_FONT,
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: 0.4,
          textTransform: "uppercase",
          color: C2.muted,
          textAlign: isRTL ? "right" : "left",
        }}
      >
        {t(title)}
      </Typography>
      <Typography
        sx={{
          fontFamily: C2_FONT,
          fontSize: 16,
          fontWeight: 700,
          color: C2.sidebar,
          wordBreak: "break-word",
          textAlign: isRTL ? "right" : "left",
          lineHeight: 1.35,
        }}
      >
        {display}
      </Typography>
    </Box>
  );
}

export default Userinfo;
